import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import TableDataLayerProbe from "../components/TableDataLayerProbe";

const TableDataPageProbe = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Probe Cases list */}
        <TableDataLayerProbe />
      </MasterLayout>
    </>
  );
};

export default TableDataPageProbe;
